// import './styles/tailwind.css'
// import './assets/fonts/zt/icon-font/icon-font.css'
import '../../sichern-vue-package-icons/dist/zt-icon-svg.css'

import useWindowResize from './hooks/useWindowResize'

import ztButton from './components/atomic/atoms/ztButton'
import ztInput from './components/atomic/atoms/ztInput'
import ztIcon from './components/atomic/atoms/ztIcon'
import ztProgressBar from './components/atomic/atoms/ztProgressBar'
import ztSelect from './components/atomic/atoms/ztSelect'
import ztCheckBox from './components/atomic/atoms/ztCheckBox'
import ztRadioButton from './components/atomic/atoms/ztRadioButton'
import ztChip from './components/atomic/atoms/ztChip'
import ztTooltip from './components/atomic/atoms/ztTooltip'
import ztAlert from './components/atomic/atoms/ztAlert'
import ztBreadcrumbs from './components/atomic/atoms/ztBreadcrumbs'
import ztListItem from './components/atomic/atoms/ztListItem'
import ztAvatar from './components/atomic/atoms/ztAvatar'
import ztOverlay from './components/atomic/atoms/ztOverlay'
import ztHeaderBar from './components/atomic/Organisms/ztHeaderBar'
import ztModal from './components/atomic/molecules/ztModal'
import ztMenuBar from './components/atomic/Organisms/ztMenuBar'
import ztSwitch from './components/atomic/atoms/ztSwitch'
import ztTable from './components/atomic/atoms/ztTable'
import ztAutocomplete from './components/atomic/atoms/ztAutocomplete'
import ztDropdown from './components/atomic/atoms/ztDropdown'
import ztOffCanvas from './components/atomic/molecules/ztOffCanvas'
import ztInputFile from './components/atomic/atoms/ztInputFile'
import ztBadge from './components/atomic/atoms/ztBadge'
import ztSizeProvider from './components/atomic/atoms/ztSizeProvider'
import ztTab from './components/atomic/atoms/ztTab'
import ztDataTable from './components/atomic/atoms/ztDataTable'
import ztAccordion from './components/atomic/atoms/ztAccordion'
import ztSlider from './components/atomic/molecules/ztSlider'

const ztComponents = {
  ztButton,
  ztInput,
  ztIcon,
  ztProgressBar,
  ztSelect,
  ztCheckBox,
  ztRadioButton,
  ztChip,
  ztTooltip,
  ztAlert,
  ztBreadcrumbs,
  ztListItem,
  ztAvatar,
  ztOverlay,
  ztHeaderBar,
  ztModal,
  ztMenuBar,
  ztSwitch,
  ztTable,
  ztAutocomplete,
  ztDropdown,
  ztOffCanvas,
  ztInputFile,
  ztBadge,
  ztSizeProvider,
  ztTab,
  ztDataTable,
  ztAccordion,
  ztSlider,
}

const plugin = {
  install: (Vue) => {
    Object.values(ztComponents).forEach((ztComponent) => {
      Vue.use(ztComponent)
    })
  },
}

if (typeof window !== 'undefined' && window.Vue) {
  plugin.install(window.Vue)
}

export default plugin

export {
  useWindowResize,
  ztButton,
  ztInput,
  ztIcon,
  ztProgressBar,
  ztSelect,
  ztCheckBox,
  ztRadioButton,
  ztChip,
  ztTooltip,
  ztAlert,
  ztBreadcrumbs,
  ztListItem,
  ztAvatar,
  ztOverlay,
  ztHeaderBar,
  ztModal,
  ztMenuBar,
  ztSwitch,
  ztTable,
  ztAutocomplete,
  ztDropdown,
  ztOffCanvas,
  ztInputFile,
  ztBadge,
  ztSizeProvider,
  ztTab,
  ztDataTable,
  ztAccordion,
  ztSlider,
}
